import { render } from "./CaseNotes.vue?vue&type=template&id=cf7d302c&ts=true"
import script from "./CaseNotes.vue?vue&type=script&lang=ts"
export * from "./CaseNotes.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__